// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wholesaleSellingGuide .pfs-banner-content,
.globalSellingGuide .pfs-banner-content {
  padding-bottom: 0;
}

.BC-CardB2BInfos {
  padding: 20px;
}

.BC-CardB2BInfos .heading {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  align-items: center;
  margin-bottom: 12px;
}

.BC-CardB2BInfos .card-content {
  padding: 8px 20px;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.BC-CardB2BInfos .card-content .item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 0;
}

.BC-CardB2BInfos .card-content .item > p:nth-child(1) {
  font-weight: 500;
}

.BC-CardB2BInfos .card-content .item > p:not(:first-child) {
  color: #6d7175;
}

.BC-CardB2BInfos .card-content .item:not(:last-child) {
  border-bottom: 1px solid #e1e3e5;
}

.BC-LockCardB2B {
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  background-color: #fffbf3;
  border-radius: 8px;
}

.BC-LockCardB2B .content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-LockCardB2B .action button {
  background-color: #ffc96b;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
  border: unset;
}

.BC-Page__WholesaleSelling .b2b-promote-banner {
  background: linear-gradient(163.96deg, #FFF2F9 10.15%, #E8F7FF 105.86%);
  border: 1px solid #F3774D29;
  border-radius: 8px;
  margin: 24px 0;
  position: relative;
}

.BC-Page__WholesaleSelling .b2b-promote-banner>img {
  position: absolute;
  right: 0;
}

.BC-Page__WholesaleSelling .b2b-promote-banner > div {
  display: flex;
  justify-content: space-between;
  padding: 16px;
}

.BC-Page__WholesaleSelling .b2b-promote-banner > div > div:first-child {
  display: flex;
  gap: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/b2b.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV","sourcesContent":[".wholesaleSellingGuide .pfs-banner-content,\n.globalSellingGuide .pfs-banner-content {\n  padding-bottom: 0;\n}\n\n.BC-CardB2BInfos {\n  padding: 20px;\n}\n\n.BC-CardB2BInfos .heading {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.BC-CardB2BInfos .card-content {\n  padding: 8px 20px;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-CardB2BInfos .card-content .item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 0;\n}\n\n.BC-CardB2BInfos .card-content .item > p:nth-child(1) {\n  font-weight: 500;\n}\n\n.BC-CardB2BInfos .card-content .item > p:not(:first-child) {\n  color: #6d7175;\n}\n\n.BC-CardB2BInfos .card-content .item:not(:last-child) {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-LockCardB2B {\n  padding: 10px 16px;\n  display: flex;\n  justify-content: space-between;\n  background-color: #fffbf3;\n  border-radius: 8px;\n}\n\n.BC-LockCardB2B .content {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-LockCardB2B .action button {\n  background-color: #ffc96b;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n  border: unset;\n}\n\n.BC-Page__WholesaleSelling .b2b-promote-banner {\n  background: linear-gradient(163.96deg, #FFF2F9 10.15%, #E8F7FF 105.86%);\n  border: 1px solid #F3774D29;\n  border-radius: 8px;\n  margin: 24px 0;\n  position: relative;\n}\n\n.BC-Page__WholesaleSelling .b2b-promote-banner>img {\n  position: absolute;\n  right: 0;\n}\n\n.BC-Page__WholesaleSelling .b2b-promote-banner > div {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n}\n\n.BC-Page__WholesaleSelling .b2b-promote-banner > div > div:first-child {\n  display: flex;\n  gap: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
